module.exports = __webpack_public_path__ + "static/media/hand-of-anna.57d0a51c.png";